export const resetField = setFieldValue => {
  setFieldValue('monthlyCharges', 0);
  setFieldValue('monthlyDiscount', 0);
  setFieldValue('currentPriceMonthly', 0);
  setFieldValue('oneTimeCharge', 0);
  setFieldValue('onetimeDiscount', 0);
  setFieldValue('currentPriceOneTime', 0);
};

// Helper function to set discounts
export const setDiscountFields = (data, discountField, setFieldValue, contractTerm) => {
  switch (contractTerm) {
    case '1 year':
      setFieldValue(discountField, data.oneYear);
      setFieldValue('contractTerm', 'oneYear');
      break;
    case '3 year':
      setFieldValue(discountField, data.threeYears);
      setFieldValue('contractTerm', 'threeYears');
      break;
    case '5 year':
      setFieldValue(discountField, data.fiveYears);
      setFieldValue('contractTerm', 'fiveYears');
      break;
    default:
      setFieldValue('contractTerm', '');
  }
};
